
 



 
 import {fs} from "Config/FsConfig";
 
    import SendActivateEmailData from 'Modules/Core/Scripts/AppServiceContract/SendActivateEmailData';

    import ActivateTokenRequest from 'Modules/Core/Scripts/AppServiceContract/ActivateTokenRequest';

    import ActivateData from 'Modules/Core/Scripts/AppServiceContract/ActivateData';

    import CreatePasswordData from 'Modules/Core/Scripts/AppServiceContract/CreatePasswordData';


    //module ActivateUserAppService {
    class ActivateUserAppService {

    ControllerUrl : string
    Options : JQueryAjaxSettings

    constructor(serverBaseUrl : string = null, controllerPath : string = null, ajaxOptions : JQueryAjaxSettings = null){
        this.ControllerUrl = ((serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : serverBaseUrl) + ((controllerPath == null) ?  "modules/Core.AppService/ActivateUserAppService" : controllerPath);
        this.Options = ajaxOptions;
    }

    public Init(options : any = { serverBaseUrl :  null, controllerPath : null, ajaxOptions : null }){
        this.ControllerUrl = ((options.serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : options.serverBaseUrl) + ((options.controllerPath == null) ?  "modules/Core.AppService/ActivateUserAppService" : options.controllerPath);
        this.Options = options.ajaxOptions;

        return this;
    }

    
    // post: api/${controller}/
    //public static RouteSendActivateEmail = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ActivateUserAppService/SendActivateEmail`;
    public RouteSendActivateEmail() : string {
        return this.ControllerUrl + "/"+"SendActivateEmail";
    }
    public SendActivateEmail(data: SendActivateEmailData): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteSendActivateEmail(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(data),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteCheckToken = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ActivateUserAppService/CheckToken`;
    public RouteCheckToken() : string {
        return this.ControllerUrl + "/"+"CheckToken";
    }
    public CheckToken(data: ActivateTokenRequest): JQuery.jqXHR<boolean> {
        return $.ajax({
                url: this.RouteCheckToken(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(data),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteActivateUser = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ActivateUserAppService/ActivateUser`;
    public RouteActivateUser() : string {
        return this.ControllerUrl + "/"+"ActivateUser";
    }
    public ActivateUser(data: ActivateData): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteActivateUser(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(data),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteCreatePassword = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ActivateUserAppService/CreatePassword`;
    public RouteCreatePassword() : string {
        return this.ControllerUrl + "/"+"CreatePassword";
    }
    public CreatePassword(data: CreatePasswordData): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteCreatePassword(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(data),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
}

export default ActivateUserAppService;



